<om-label *ngIf="label" [text]="label" [icon]="icon" [isRequired]="isRequired$ | async"></om-label>
<nz-time-picker
  [class]="_class"
  [formControl]="_control"
  [nzFormat]="format"
  [nzMinuteStep]="step"
  [nzPlaceHolder]="placeholder"
  [nzDisabled]="disabled"
  [nzDisabledHours]="disabledHours"
  [nzDisabledMinutes]="disabledMinutes"
  [nzDisabledSeconds]="disabledSeconds"
  [nzHideDisabledOptions]="hideDisabledOptions"
  [nzAllowEmpty]="allowClear"
  (keydown.enter)="$event.preventDefault()"
>
</nz-time-picker>
<ng-container>
  <div class="om-error-placeholder">
    <om-error [control]="control"></om-error>
  </div>
</ng-container>
